import Vue from "vue";
import Router from "vue-router";
import Home from "components/home";
import Hours from "components/hours/hours";
import Users from "components/users/users";
import UserDetails from "components/users/userDetails";
import Leaves from "components/leaves/leaves";
import LeaveEmailPage from "components/leaves/leaveEmailPage";
import LeaveCreate from "components/leaves/leaveCreate";
import Illnesses from "components/illnesses/illnesses";
import IllnessCreate from "components/illnesses/illnessCreate";
import Projects from "components/projects/projects";
import ProjectDetails from "components/projects/projectDetails";
import UserHourDetails from "components/users/userHourDetails";
import UserLeaveDetails from "components/users/userLeaveDetails";
import HoursReadonly from "components/users/hoursReadonly";
import HoursDateRange from "components/users/userHoursDateRange";
import Account from "components/account";
import AccountChangePassword from "components/account/changePassword";
import Login from "components/login";
import ForgotPassword from "components/login/reset/forgotPassword";
import ResetPassword from "components/login/reset/resetPassword";

import store from "../store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/hours",
      name: "Hours",
      component: Hours
    },
    {
      path: "/users/users",
      name: "Users",
      component: Users
    },
    {
      path: "/users/userDetails",
      name: "UserDetails",
      component: UserDetails
    },
    {
      path: "/users/hoursReadonly",
      name: "hoursReadonly",
      component: HoursReadonly
    },
    {
      path: "/users/userHoursDateRange",
      name: "userHoursDateRange",
      component: HoursDateRange
    },
    {
      path: "/leaves",
      name: "Leaves",
      component: Leaves
    },
    {
      path: "/leaveEmailPage",
      name: "LeaveEmailPage",
      component: LeaveEmailPage
    },
    {
      path: "/leaves/leaveCreate",
      name: "LeaveCreate",
      component: LeaveCreate
    },
    {
      path: "/illnesses",
      name: "Illnesses",
      component: Illnesses
    },
    {
      path: "/illnesses/illnessCreate",
      name: "IllnessCreate",
      component: IllnessCreate
    },
    {
      path: "/projects",
      name: "Projects",
      component: Projects
    },
    {
      path: "/projects/projectDetails",
      name: "ProjectDetails",
      component: ProjectDetails
    },
    {
      path: "/users/hourDetails",
      name: "HourDetails",
      component: UserHourDetails
    },
    {
      path: "/users/leaveDetails",
      name: "LeaveDetails",
      component: UserLeaveDetails
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/account/changePassword",
      name: "ChangePassword",
      component: AccountChangePassword,
      beforeEnter: ifAuthenticated
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/forgotPassword",
      name: "ForgotPassword",
      component: ForgotPassword,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/resetPassword",
      name: "ResetPassword",
      component: ResetPassword,
      beforeEnter: ifNotAuthenticated
    },
    //{ path: '*', component: NotFoundComponent } //This component doesn't exist. For explanation, see https://router.vuejs.org/guide/essentials/history-mode.html#caveat
  ]
});
